import Typography from '@mui/material/Typography'

export const DataGridCellText = ({ children, py = 1 }: { children: React.ReactNode; py?: number }) => (
  <Typography
    variant="body2"
    sx={{
      fontSize: '14px',
      py,
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    }}
  >
    {children}
  </Typography>
)
